import { z } from 'zod/v4';

const tableEventSchema = z.object({
  channel: z.string(),
  table: z.string(),
  operation: z.enum(['INSERT', 'UPDATE', 'DELETE']),
  id: z.union([z.string(), z.number()]),
  timestamp: z.iso.datetime(),
});

const syncCompletionEventSchema = z.object({
  kind: z.literal('sync'),
  channel: z.string(),
  event: z.enum(['sync-inventory-refresh-complete', 'analytics-sync-complete']),
  payload: z.object({
    jobType: z.string(),
    completedAt: z.iso.datetime(),
  }),
  timestamp: z.iso.datetime(),
});

export const realtimeEventSchema = z.union([tableEventSchema, syncCompletionEventSchema]);

export type RealtimeEvent = z.infer<typeof realtimeEventSchema>;

export type ConnectionState = 'connecting' | 'connected' | 'disconnected' | 'reconnecting';

export const websocketMessageSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('event'),
    payload: realtimeEventSchema.optional(),
  }),
  z.object({
    type: z.literal('subscribe'),
    payload: z.object({ channels: z.array(z.string()) }),
  }),
  z.object({
    type: z.literal('unsubscribe'),
    payload: z.object({ channels: z.array(z.string()) }),
  }),
  z.object({ type: z.literal('ping') }),
  z.object({ type: z.literal('pong') }),
]);

export type WebsocketMessage = z.infer<typeof websocketMessageSchema>;
